import {environment} from '../../../environments/environment';
import {Component, DoCheck, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {DataService} from '../../services/data.service';
import {ApplicationService} from '../../services/application.service';
import {EnumerationService} from '../../services/enumeration.service';
import {ExcSecurityService} from 'exc-security-v2';
import {ExgModalService, ExgOverlayService} from 'exc-controls-v2';
import {ExcRestService} from 'exc-rest-v2';
import {ExcTranslation} from 'exc-core-v2';
import {ExgEventArgs} from '../../misc/classes/ExgEventArgs';
import {ExgApplicationEventEmitter} from '../../misc/classes/ExgApplicationEventEmitter';

@Component({
  selector: 'app-report-doc-result',
  templateUrl: 'report-doc-result.component.html',
  styles: [
  ]
})
export class ReportDocResultComponent extends ExcTranslation implements OnInit, OnChanges, DoCheck {

  Events = new ExgApplicationEventEmitter();
  @Input() vorgOrAuNr = '';
  @Input() auID = '';
  @Input() taskList: any[] = [];
  @Input() aueSchadenNr = '';
  @Input() selectKey = '';
  @Input() arrangedDocs: any[] = [];
  @Input() isVisible = false;
  @Input() tabinstance: any = {};
  @Input() oeID = '';

  private lastLoadedDocsJson = '';
  private currentDocsJson = '';
  private lastLoadedConfigJson = '';
  private wasVisible = false;
  private pendingCheckRequired = false;

  availableTemplates: any[] = [];
  templatesByFolder: { [key: string]: any[] } = {};
  showTemplateSelection = false;
  selectedTemplatePreview = 'standard';
  selectedTemplateIndex = 0;


  saveModel: any = {};
  isLoading = true;

  auftragNr = '';

  saveToTask = true;
  saveToCase = true;

  private _currentResource: any;
  selectedTaskIndex = 0;
  get currentResource(): any {
    return this._currentResource;
  }

  set currentResource(value: any) {
    this.isLoading = true;
    this._currentResource = value;
  }
  constructor(
    private dataSvc: DataService,
    public appSvc: ApplicationService,
    public enumSvc: EnumerationService,
    public excSecurity: ExcSecurityService,
    public overlayService: ExgOverlayService,
    private modal: ExgModalService,
    public excRest: ExcRestService) {
    super();
  }

  ngOnInit(): void {
    this.registerEvents();

    this.loadAvailableTemplates();

    this.saveModel.templateId = 'ReportBuilderCover1';
    this.selectedTemplatePreview = 'ReportBuilderCover1';

    const today = new Date();
    const isoString = today.toISOString(); // z.B. "2025-07-16T13:27:45.123Z"

    const isoDateOnly = isoString.split('T')[0]; // "2025-07-16"
    this.saveModel.dokName = isoDateOnly + '_Bericht_' + this.vorgOrAuNr;
    this.saveModel.hasCover = false;

    this.setAuftragNr();
    this.lastLoadedConfigJson = JSON.stringify(this.saveModel);
  }


  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.isVisible) {
      if (this.isVisible && this.pendingCheckRequired) {
        this.triggerLoadIfNecessary();
        this.pendingCheckRequired = false;
      }
      this.wasVisible = this.isVisible;
    }
  }

  ngDoCheck(): void {
    this.currentDocsJson = JSON.stringify(this.arrangedDocs ?? []);
    const currentConfigJson = JSON.stringify({
      hasCover: this.saveModel.hasCover,
      templateId: this.saveModel.templateId
    });

    const hasChangedSinceLastLoad = this.currentDocsJson !== this.lastLoadedDocsJson || currentConfigJson !== this.lastLoadedConfigJson;
    if (hasChangedSinceLastLoad) {
      if (this.isVisible) {
        this.triggerLoadIfNecessary();
      } else {
        this.pendingCheckRequired = true;
      }
    }
  }

  registerEvents(): void {
    this.Events.ReportBuilder.Preview?.Create?.subscribe((evt: ExgEventArgs) => {
      if (evt.success && evt.data?.rbuipID) {
        this.generateUrl(evt.data.rbuip_uid, evt.data.rbuipID);
      }
    });
  }

  private triggerLoadIfNecessary(): void {
    const currentJson = JSON.stringify(this.arrangedDocs ?? []);
    const currentConfigJson = JSON.stringify({
      hasCover: this.saveModel.hasCover,
      templateId: this.saveModel.templateId
    });
    const hasChanged = currentJson !== this.lastLoadedDocsJson || currentConfigJson !== this.lastLoadedConfigJson;

    if (hasChanged) {
      this.lastLoadedDocsJson = currentJson;
      this.lastLoadedConfigJson = currentConfigJson;
      this.createPDFPreview();
    }
  }

  private createPDFPreview(): void {
    if (this.arrangedDocs.length && this.excSecurity.isFeatured('REPORTBUILDER')) {

      const jsonString = JSON.stringify({
        hasCover: this.saveModel.hasCover,
        dokName: this.saveModel.dokName,
        templateId: this.saveModel.templateId,
        arrangementArray: this.arrangedDocs,
        aueSchadenNr: this.aueSchadenNr,
        vorgOrAuNr: this.vorgOrAuNr,
        footerText: this.saveModel.footerText
      });

      const payload = {
        rbuipJSON: jsonString,
        rbuip_uiKey: this.tabinstance._id,
      };
      this.appSvc.ReportBuilder.DocBuilder.PreviewCreate(payload, {Events: this.Events});
    }
    else {
      this.modal.showToast('Arrangierung fehlgeschlagen', 'md-toast', 'fas fa-exclamation');
    }
  }

  generateUrl(uid: string, rbuipID: string): void {
    const endpointTemplate = environment.rest.ServiceUrl + '/' + environment.rest.Endpoints.BerichtsBuilderPreviewR;
    const url = endpointTemplate
      .replace('{uid}', encodeURIComponent(uid))
      .replace('{rbuipID}', encodeURIComponent(rbuipID));

    // Optional: Wenn du sie speichern willst
    this.currentResource = url;
  }

  stopLoadingPDF(event: any): void {
    if (event) { this.isLoading = false; }
  }

  downloadReportDocPDF(): void {
    if (this.arrangedDocs.length && this.excSecurity.isFeatured('REPORTBUILDER')) {

      const jsonString = JSON.stringify({
        hasCover: this.saveModel.hasCover
        , dokName: this.saveModel.dokName
        , templateId: this.saveModel.templateId
        , arrangementArray: this.arrangedDocs
        , aueSchadenNr: this.aueSchadenNr
        , vorgOrAuNr: this.vorgOrAuNr
        , footerText: this.saveModel.footerText
      });
      const payload = {bbData: jsonString, dok_enmIdent_DokTyp: 3};


      this.modal.showToast('Download wird gestartet', 'md-toast', 'fas fa-download');
      this.excRest.post(
        this.excRest.computeUrl('BerichtsBuilder_Download', {}), payload, {export: true}
      ).subscribe((response: any) => {
        if (response && response.success) {
          this.modal.showToast('Download gestartet', 'md-toast bg-green', 'fas fa-download');
        } else {
          this.modal.showToast('Download fehlgeschlagen', 'md-toast bg-red', 'fas fa-exclamation');
        }
      });
    }
    else {
      this.modal.showToast('Arrangierung fehlgeschlagen', 'md-toast bg-red', 'fas fa-exclamation');
    }
  }


  saveReportDoc(): void {
    if (this.arrangedDocs.length
      && this.excSecurity.isFeatured('REPORTBUILDER')
      && (this.saveToCase || this.saveToTask)
    ) {
      const jsonString = JSON.stringify({
        hasCover: this.saveModel.hasCover
        , dokName: this.saveModel.dokName
        , templateId: this.saveModel.templateId
        , arrangementArray: this.arrangedDocs
        , aueSchadenNr: this.aueSchadenNr
        , vorgOrAuNr: this.vorgOrAuNr
        , footerText: this.saveModel.footerText
      });
      const payload = {bbData: jsonString, dok_enmIdent_DokTyp: 3};

      if (this.saveToCase) {
        Object.assign(payload, {auID: this.auID});
      }
      if (this.saveToTask && this.selectedTaskIndex >= 0) {
        const selectedTask = this.taskList[this.selectedTaskIndex];
        Object.assign(payload, {vorgID: selectedTask.vorgID});
      }

      this.modal.showToast('Report wird erstellt', 'md-toast', 'fas fa-floppy-disk');

      this.excRest.post(
        this.excRest.computeUrl('BerichtsBuilderC_Dokument', { }), payload
      ).subscribe((response: any) => {
        if (response && response.success && response.data) {
          this.modal.showToast('Report erstellt', 'md-toast bg-green', 'fas fa-floppy-disk');
        } else {
          this.modal.showToast('Report Erstellung fehlgeschlagen', 'md-toast bg-red', 'fas fa-exclamation');
        }
      });
    }
    else {
      this.modal.showToast('Arrangierung fehlgeschlagen', 'md-toast bg-red', 'fas fa-exclamation');
    }
  }

  private setAuftragNr(): void {
    if (this.selectKey === 'auID') {
      this.auftragNr = this.vorgOrAuNr;
    } else {
      if (this.taskList.length > 0) {
        const currentTask = this.taskList.find(task => task.vorgNr === this.vorgOrAuNr);
        this.auftragNr = currentTask?.auNr || '';
      }
    }
  }

  showTemplateModal(): void {
    this.selectedTemplatePreview = this.saveModel.templateId || 'ReportBuilderCover1'; // todo default first element
    this.showTemplateSelection = true;
  }

  hideTemplateModal(): void {
    this.showTemplateSelection = false;
  }

  selectTemplatePreview(templateId: string): void {
    this.selectedTemplatePreview = templateId;
  }

  applyTemplate(): void {
    this.saveModel.templateId = this.selectedTemplatePreview;

    this.selectedTemplateIndex = this.availableTemplates.findIndex(i => i.id === this.selectedTemplatePreview);

    this.hideTemplateModal();
    this.triggerLoadIfNecessary();
  }

  onTemplateDropdownChange(): void {
    if (this.selectedTemplateIndex >= 0 && this.availableTemplates[this.selectedTemplateIndex]) {
      this.saveModel.templateId = this.availableTemplates[this.selectedTemplateIndex].id;
      this.selectedTemplatePreview = this.availableTemplates[this.selectedTemplateIndex].id;
    }
  }

  private loadAvailableTemplates(): void {
    const oeID = this.oeID;

    this.excRest.get(
      this.excRest.computeUrl('BerichtsBuilder_Templates', { oeID })
    ).subscribe((response: any) => {
      if (response && response.success && response.data && response.data.templates) {
        this.availableTemplates = response.data.templates.map((t: any) => ({
          id: t.id,
          name: t.name,
          source: t.source,
          folder: t.folder || 'Sonstiges',
          previewUrl: this.excRest.computeUrl('BerichtsBuilder_TemplatePreview', { streamId: t.id })
        }));

        this.templatesByFolder = this.groupTemplatesByFolder();

        if (!this.availableTemplates.find(t => t.id === this.saveModel.templateId) && this.availableTemplates.length > 0) {
          this.saveModel.templateId = this.availableTemplates[0].id;
          this.selectedTemplatePreview = this.availableTemplates[0].id;
        }
      } else {
        this.availableTemplates = [];
        this.templatesByFolder = {};
      }
    });
  }
  private groupTemplatesByFolder(): { [key: string]: any[] } {
    const grouped: { [key: string]: any[] } = {};
    this.availableTemplates.forEach(template => {
      const folderKey = `${template.source} - ${template.folder}`;
      if (!grouped[folderKey]) {
        grouped[folderKey] = [];
      }
      grouped[folderKey].push(template);
    });
    return grouped;
  }
}

